// extracted by mini-css-extract-plugin
module.exports = {"icon":"PaperFormIndicator_icon__eLi1X"};